import { bgOverlayStyle } from "@/utils/helpers";
import { AppShell } from "@/components/Navbar";
import { ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { isRTLLanguage } from "@/utils/helpers";
import { cn } from "@/lib/utils";
import { ScrollIndicator } from "@/components/Helpers/ScrollIndicator";

interface HeaderProps {
  title?: string | ReactNode;
  picture?: string;
  light?: boolean;
  aboutUs?: boolean;
  scrollHref: string;
}

export const Header: React.FC<HeaderProps> = ({
  title,
  picture,
  light = false,
  aboutUs = false,
  scrollHref,
}) => {
  const backgroundStyle = bgOverlayStyle(picture ?? "");
  const { i18n, t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="description" content={`${title} page`} />
      </Helmet>
      <div className="flex h-14 items-center justify-between bg-foreground px-4 md:px-[24px]">
        <div className="flex flex-row gap-1 text-white">
          {t("join.first_part")}{" "}
          <Link
            aria-label={t("join.first_part") + " " + t("join.second_part")}
            to="/coh"
            search={{ tab: "" }}
          >
            <p className="font-bold text-white underline"> {t("join.second_part")}</p>
          </Link>
        </div>
        <Link
          aria-label={t("join.first_part") + " " + t("join.second_part")}
          to="/coh"
          search={{ tab: "" }}
        >
          {isRTLLanguage(i18n.language) ? (
            <img src="/coh-logo-ar-white.svg" className="h-8" />
          ) : (
            <img src="/coh-logo-white.svg" className="h-8" />
          )}
        </Link>
      </div>

      <AppShell theme="dark" navbarClass="top-14 absolute w-full" light={light} />
      <div
        className="dark relative h-[65vh] w-full bg-cover bg-center md:h-[calc(70vh-5rem)]"
        style={{
          backgroundImage: backgroundStyle,
        }}
      >
        <div className="flex h-full flex-shrink-0 flex-col items-start justify-end self-stretch p-4 sm:flex-row sm:items-end sm:justify-start md:p-6 md:pb-0">
          <div className="mb-6 w-full">
            <h1
              className={cn(
                "text-40px font-bold leading-[40px] text-white rtl:pb-4",
                aboutUs
                  ? "md:text-4xl md:leading-[55px] lg:text-5xl lg:leading-[70px]"
                  : "md:text-96px md:leading-[96px]",
              )}
            >
              {title}
            </h1>
          </div>
          <ScrollIndicator mode="light" href={scrollHref} />
        </div>
      </div>
    </>
  );
};
